import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { Route } from 'react-router';
import { Grid, StylesProvider, ThemeProvider } from '@material-ui/core';
import theme from '@prime/theme';

import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import '@prime/theme/lib/styles/index.css';
import '@prime/core/lib/styles/index.css';

import Dashboard from './features/Dashboard';
import { ROUTES } from './core/router/routes';
import AppBar from './components/AppBar';
import ArticleRoute from './features/article/router/ArticleRoute';
import CategoryRoute from './features/category/router/CategoryRoute';
import MainProgressProvider from './components/progress/MainProgress/provider/MainProgressProvider';
import ResultsProgressProvider from './components/progress/ResultsProgress/provider/ResultsProgressProvider';

import './App.scss';

const App: React.FC = () => {
  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Grid container className="Grid-root" spacing={0}>
          <Grid item className="Grid-appBar">
            <AppBar />
          </Grid>
          <Grid item className="Grid-container">
            <MainProgressProvider>
              <ResultsProgressProvider>
                <Switch>
                  <Route exact path={ROUTES.DEFAULT} render={() => <Redirect to={ROUTES.DASHBOARD} />} />
                  <Route path={ROUTES.DASHBOARD} component={Dashboard} />
                  {CategoryRoute()}
                  {ArticleRoute()}
                  <Route render={() => <Redirect to={ROUTES.ERROR_404} />} />
                </Switch>
              </ResultsProgressProvider>
            </MainProgressProvider>
          </Grid>
        </Grid>
      </ThemeProvider>
    </StylesProvider>
  );
};

export default App;
